"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventHandler2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/event/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Component Event Handler.
 */
var ComponentEventHandler = /*#__PURE__*/function (_EventHandler) {
  _inherits(ComponentEventHandler, _EventHandler);

  var _super = _createSuper(ComponentEventHandler);

  /**
   * Class constructor.
   *
   * @param {object} options Options object.
   * @param {string[]} options.supportedEvents Supported events.
   * @param {string} options.componentName Component name.
   * @param {CacheStore} options.cacheStore Cache store.
   * @param {object} [options.scope] Scope to call callback in.
   */
  function ComponentEventHandler(options) {
    var _this;

    _classCallCheck(this, ComponentEventHandler);

    _this = _super.call(this, options);
    _this._cacheStore = options.cacheStore;
    _this._storedEvents = {};
    return _this;
  }
  /**
   * Handles stored events.
   *
   * @throws ComponentException
   * @param {string} uniqueId Unique id.
   */


  _createClass(ComponentEventHandler, [{
    key: "updateStoredEvents",
    value: function updateStoredEvents(uniqueId) {
      var storedEvents = this._cacheStore.getEvents(uniqueId);

      this._cacheStore.removeEvents(uniqueId);

      if (storedEvents) {
        this._eventsUniqueId = uniqueId;

        for (var key in this._storedEvents) {
          if (this._storedEvents.hasOwnProperty(key)) {
            this.off(key, this._storedEvents[key]);
          }
        }

        for (var _key in storedEvents) {
          if (storedEvents.hasOwnProperty(_key) && typeof storedEvents[_key] === 'function') {
            this._storedEvents[_key] = storedEvents[_key];
            this.on(_key, storedEvents[_key]);
          }
        }
      }
    }
  }]);

  return ComponentEventHandler;
}(_EventHandler2.default);

exports.default = ComponentEventHandler;